export const restaurants = [
  {
    id: 1,
    name: "Burger Palace",
    image: "https://images.unsplash.com/photo-1586190848861-99aa4a171e90?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1280&q=80",
    rating: 4.5,
    deliveryTime: "25-35 min",
    deliveryFee: 2.99,
    cuisine: "American",
    description: "Best burgers in town!"
  },
  {
    id: 2,
    name: "Pizza Heaven",
    image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    rating: 4.3,
    deliveryTime: "30-40 min",
    deliveryFee: 1.99,
    cuisine: "Italian",
    description: "Authentic Italian pizza"
  },
  {
    id: 3,
    name: "Sushi Express",
    image: "https://images.unsplash.com/photo-1611143669185-af224c5e3252?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    rating: 4.8,
    deliveryTime: "20-30 min",
    deliveryFee: 3.99,
    cuisine: "Japanese",
    description: "Fresh sushi delivered fast"
  },
  {
    id: 4,
    name: "Taco Fiesta",
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    rating: 4.2,
    deliveryTime: "15-25 min",
    deliveryFee: 1.49,
    cuisine: "Mexican",
    description: "Authentic Mexican flavors"
  },
  {
    id: 5,
    name: "Thai Delight",
    image: "https://images.unsplash.com/photo-1559847844-5315695dadae?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1158&q=80",
    rating: 4.6,
    deliveryTime: "30-45 min",
    deliveryFee: 2.49,
    cuisine: "Thai",
    description: "Authentic Thai cuisine with the perfect balance of flavors"
  },
  {
    id: 6,
    name: "Mediterranean Oasis",
    image: "https://images.unsplash.com/photo-1540914124281-342587941389?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80",
    rating: 4.7,
    deliveryTime: "25-40 min",
    deliveryFee: 2.99,
    cuisine: "Mediterranean",
    description: "Fresh ingredients from the Mediterranean coastline"
  },
  {
    id: 7,
    name: "Indian Spice",
    image: "https://images.unsplash.com/photo-1505253758473-96b7015fcd40?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1190&q=80",
    rating: 4.4,
    deliveryTime: "35-50 min",
    deliveryFee: 1.99,
    cuisine: "Indian",
    description: "Rich and flavorful Indian dishes made with traditional spices"
  },
  {
    id: 8,
    name: "Noodle House",
    image: "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1180&q=80",
    rating: 4.5,
    deliveryTime: "20-35 min",
    deliveryFee: 1.99,
    cuisine: "Asian Fusion",
    description: "Variety of noodles from across Asia with a modern twist"
  }
];

export const menuItems = {
  1: [
    {
      id: 101,
      name: "Classic Burger",
      description: "Beef patty, lettuce, tomato, onion, pickles, and our special sauce",
      price: 179,
      image: "https://images.unsplash.com/photo-1571091718767-18b5b1457add?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1172&q=80"
    },
    {
      id: 102,
      name: "Cheese Burger",
      description: "Beef patty, cheese, lettuce, tomato, onion, and mayo",
      price: 199,
      image: "https://images.unsplash.com/photo-1598182198871-d3f4ab4fd181?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 103,
      name: "French Fries",
      description: "Crispy golden fries",
      price: 99,
      image: "https://images.unsplash.com/photo-1630384060421-cb20d0e0649d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1025&q=80"
    },
    {
      id: 104,
      name: "BBQ Bacon Burger",
      description: "Beef patty, crispy bacon, cheddar cheese, and BBQ sauce",
      price: 249,
      image: "https://images.unsplash.com/photo-1594212699903-ec8a3eca50f5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1171&q=80"
    },
    {
      id: 105,
      name: "Chicken Tenders",
      description: "Crispy chicken tenders served with dipping sauce",
      price: 159,
      image: "https://images.unsplash.com/photo-1626645738196-c2a7c87a8f58?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 106,
      name: "Onion Rings",
      description: "Crispy battered onion rings",
      price: 109,
      image: "https://images.unsplash.com/photo-1619881590738-a111ad7e7c44?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    }
  ],
  2: [
    {
      id: 201,
      name: "Margherita",
      description: "Tomato sauce, mozzarella, and basil",
      price: 249,
      image: "https://images.unsplash.com/photo-1604068549290-dea0e4a305ca?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80"
    },
    {
      id: 202,
      name: "Pepperoni",
      description: "Tomato sauce, mozzarella, and pepperoni",
      price: 279,
      image: "https://images.unsplash.com/photo-1534308983496-4fabb1a015ee?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1176&q=80"
    },
    {
      id: 203,
      name: "Garlic Bread",
      description: "Freshly baked bread with garlic butter",
      price: 99,
      image: "https://images.unsplash.com/photo-1619531038896-deaff53d151a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 204,
      name: "Vegetarian Supreme",
      description: "Tomato sauce, mozzarella, bell peppers, olives, onions, and mushrooms",
      price: 299,
      image: "https://images.unsplash.com/photo-1593560708920-61dd98c46a4e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1035&q=80"
    },
    {
      id: 205,
      name: "BBQ Chicken",
      description: "BBQ sauce, mozzarella, grilled chicken, red onion, and cilantro",
      price: 329,
      image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1026&q=80"
    },
    {
      id: 206,
      name: "Meat Lovers",
      description: "Tomato sauce, mozzarella, pepperoni, sausage, bacon, and ham",
      price: 349,
      image: "https://images.unsplash.com/photo-1594007654729-407eedc4be65?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=728&q=80"
    }
  ],
  3: [
    {
      id: 301,
      name: "California Roll",
      description: "Crab, avocado, cucumber",
      price: 199,
      image: "https://images.unsplash.com/photo-1617196034183-421b4917c92d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 302,
      name: "Salmon Nigiri",
      description: "Fresh salmon over rice",
      price: 249,
      image: "https://images.unsplash.com/photo-1583623025817-d180a2221d0a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1171&q=80"
    },
    {
      id: 303,
      name: "Miso Soup",
      description: "Traditional Japanese soup",
      price: 89,
      image: "https://images.unsplash.com/photo-1626201850129-a96e127683a7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 304,
      name: "Dragon Roll",
      description: "Eel, crab, cucumber topped with avocado",
      price: 299,
      image: "https://images.unsplash.com/photo-1617196033744-de6c0f4b3622?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 305,
      name: "Tuna Sashimi",
      description: "Fresh sliced tuna (5 pieces)",
      price: 259,
      image: "https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1178&q=80"
    },
    {
      id: 306,
      name: "Tempura Udon",
      description: "Udon noodle soup with shrimp and vegetable tempura",
      price: 279,
      image: "https://images.unsplash.com/photo-1618841557871-b4664fbf0cb3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    }
  ],
  4: [
    {
      id: 401,
      name: "Carne Asada Taco",
      description: "Grilled steak with onions and cilantro",
      price: 79,
      image: "https://images.unsplash.com/photo-1552332386-f8dd00dc2f85?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1171&q=80"
    },
    {
      id: 402,
      name: "Chicken Quesadilla",
      description: "Grilled chicken and cheese in a flour tortilla",
      price: 179,
      image: "https://images.unsplash.com/photo-1618040996337-56904b7850b4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 403,
      name: "Guacamole & Chips",
      description: "Fresh guacamole with tortilla chips",
      price: 119,
      image: "https://images.unsplash.com/photo-1583577612013-4fecf7bf8f13?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80"
    },
    {
      id: 404,
      name: "Beef Burrito",
      description: "Seasoned beef, rice, beans, cheese, and pico de gallo wrapped in a flour tortilla",
      price: 199,
      image: "https://images.unsplash.com/photo-1584031036380-3fb6f2d51880?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 405,
      name: "Fish Tacos",
      description: "Grilled fish with cabbage slaw and chipotle mayo",
      price: 219,
      image: "https://images.unsplash.com/photo-1611250188496-e966043a0629?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1025&q=80"
    },
    {
      id: 406,
      name: "Churros",
      description: "Mexican fried pastry with cinnamon sugar",
      price: 99,
      image: "https://images.unsplash.com/photo-1626197031507-c5c4579cbe4c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    }
  ],
  5: [
    {
      id: 501,
      name: "Pad Thai",
      description: "Stir-fried rice noodles with egg, tofu, bean sprouts and peanuts",
      price: 239,
      image: "https://images.unsplash.com/photo-1637806876087-02f1c5861d6d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 502,
      name: "Green Curry",
      description: "Thai green curry with coconut milk, vegetables and choice of protein",
      price: 259,
      image: "https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 503,
      name: "Tom Yum Soup",
      description: "Hot and sour soup with lemongrass, lime leaves, and mushrooms",
      price: 199,
      image: "https://images.unsplash.com/photo-1548943487-a2e4e43b4853?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 504,
      name: "Mango Sticky Rice",
      description: "Sweet coconut sticky rice with fresh mango slices",
      price: 139,
      image: "https://images.unsplash.com/photo-1621236378699-8597faf6a171?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    }
  ],
  6: [
    {
      id: 601,
      name: "Hummus Platter",
      description: "Creamy hummus served with warm pita bread and olives",
      price: 179,
      image: "https://images.unsplash.com/photo-1577906096429-f73c2c312435?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 602,
      name: "Falafel Wrap",
      description: "Crispy falafel with tahini sauce, vegetables wrapped in warm pita",
      price: 199,
      image: "https://images.unsplash.com/photo-1615175391071-69cc846f869a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 603,
      name: "Greek Salad",
      description: "Fresh cucumbers, tomatoes, olives, feta cheese with olive oil dressing",
      price: 179,
      image: "https://images.unsplash.com/photo-1608032037716-dbe1f8b5a282?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 604,
      name: "Lamb Kebab Plate",
      description: "Grilled lamb kebab with rice, salad, and tzatziki sauce",
      price: 319,
      image: "https://images.unsplash.com/photo-1644364935906-dca34c2c1c64?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    }
  ],
  7: [
    {
      id: 701,
      name: "Butter Chicken",
      description: "Creamy tomato curry with tender chicken pieces",
      price: 279,
      image: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1071&q=80"
    },
    {
      id: 702,
      name: "Vegetable Biryani",
      description: "Fragrant basmati rice cooked with mixed vegetables and aromatic spices",
      price: 229,
      image: "https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 703,
      name: "Garlic Naan",
      description: "Soft bread with garlic, baked in tandoor oven",
      price: 79,
      image: "https://images.unsplash.com/photo-1610057099431-d73a1c9d2f2f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80"
    },
    {
      id: 704,
      name: "Samosa (2pc)",
      description: "Crispy pastry filled with spiced potatoes and peas",
      price: 99,
      image: "https://images.unsplash.com/photo-1589302168068-964664d93dc0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80"
    }
  ],
  8: [
    {
      id: 801,
      name: "Ramen",
      description: "Japanese wheat noodles in a rich pork broth with char siu and soft-boiled egg",
      price: 259,
      image: "https://images.unsplash.com/photo-1623341214825-9f4f963727da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 802,
      name: "Pad See Ew",
      description: "Thai stir-fried wide rice noodles with soy sauce, vegetables and choice of protein",
      price: 239,
      image: "https://images.unsplash.com/photo-1562967914-01efa7e87832?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1173&q=80"
    },
    {
      id: 803,
      name: "Dan Dan Noodles",
      description: "Spicy Sichuan noodles with minced pork and scallions",
      price: 219,
      image: "https://images.unsplash.com/photo-1619894991209-9f9a1b7cd528?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
      id: 804,
      name: "Spring Rolls (4pc)",
      description: "Crispy vegetable spring rolls with sweet chili dipping sauce",
      price: 119,
      image: "https://images.unsplash.com/photo-1563167576597-11d912292de8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    }
  ]
};
